export const SUPER_ADMIN_USERNAME = 'admin'
export const SUPER_ADMIN_ROLE_NAME = '超级管理员'

export function isSuperAdmin(username, roles) {
  if (username === SUPER_ADMIN_USERNAME) {
    return true
  }
  return Array.isArray(roles) && roles.includes(SUPER_ADMIN_ROLE_NAME)
}



// WEBPACK FOOTER //
// ./src/utils/superAdmin.js